var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, makeObservable } from 'mobx';
import { default as seededshuffle } from 'seededshuffle';
import { Question } from '../../classes/question/Question';
import { ChoiceInfo } from './modules/ChoiceInfo';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { ChoiceEval } from '../MultipleChoice/modules/ChoiceEval';
import { ChoiceKeyboardSelect } from '../MultipleChoice/modules/ChoiceKeyboardSelect';
import { ChoiceEdit } from './modules/ChoiceEdit';
import { strip } from '../../utils/serializr/schema/inner/strip';
import { ChoiceAttempts } from './modules/ChoiceAttempts';
import { ChoiceSelections } from './modules/ChoiceSelections';
export class Choice extends Question {
    MAX_OPTIONS = 99;
    isCompletedPrematurely = false;
    choiceStore;
    selections = observable.array();
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get exportingChildren() {
        return [...super.exportingChildren, ...this.options];
    }
    get questionTypeStore() {
        return this.choiceStore;
    }
    get choiceAttempts() {
        return new ChoiceAttempts(this);
    }
    get choiceSelections() {
        return new ChoiceSelections(this);
    }
    get choiceInfo() {
        return new ChoiceInfo(this);
    }
    get choiceEval() {
        return new ChoiceEval(this);
    }
    get choiceKeyboardSelect() {
        return new ChoiceKeyboardSelect(this);
    }
    get choiceEdit() {
        return new ChoiceEdit(this);
    }
    get allOptions() {
        return this.choiceStore.allOptions;
    }
    get options() {
        return (this.allOptions && this.allOptions.slice(0, this.choiceStore.numberOfOptions)) || [];
    }
    get shuffledOptions() {
        if (!this.shouldShuffle) {
            return this.options;
        }
        return seededshuffle.shuffle(this.options, this.shuffleSeed, true);
    }
    get hoveringOption() {
        return this.options.find(option => option.isOptionHovering);
    }
    get preselectingOption() {
        return this.choiceKeyboardSelect.keyboardOption;
        // 13.09.2019 || this.hoveringOption !! kick out, bad performance because needs hover listeners for all option aspects (hunderterfeld)
    }
    static get stripInfo() {
        return {
            extends: Question.stripInfo,
            props: {
                options: strip((q) => q.options.map(option => option.stripped)),
            },
        };
    }
}
__decorate([
    observable
], Choice.prototype, "isCompletedPrematurely", void 0);
__decorate([
    observable.shallow
], Choice.prototype, "selections", void 0);
__decorate([
    memoize
], Choice.prototype, "choiceAttempts", null);
__decorate([
    memoize
], Choice.prototype, "choiceSelections", null);
__decorate([
    memoize
], Choice.prototype, "choiceInfo", null);
__decorate([
    memoize
], Choice.prototype, "choiceEval", null);
__decorate([
    memoize
], Choice.prototype, "choiceKeyboardSelect", null);
__decorate([
    memoize
], Choice.prototype, "choiceEdit", null);
__decorate([
    computed
], Choice.prototype, "shuffledOptions", null);
__decorate([
    computed
], Choice.prototype, "preselectingOption", null);
__decorate([
    memoize
], Choice, "stripInfo", null);
/*

earlyReference needed because accessed before deserialize (by @computed)

 */
